export const APOLLO_CONTEXT_ROOT = '/jsd-apollo';
export const APOLLO_STARGATE_CONTEXT_ROOT = '/gateway/api/jsd-apollo-stargate/sharded/workspace';
